import { useEffect, useState } from 'react'
import { datadogRum } from '@datadog/browser-rum'

import * as newTailRepository from 'scripts/api/new-tail'

import { useDeviceType } from 'site/utils/useDeviceType'

const useBannersAds = props => {
  const {
    context,
    position,
    userId,
    sessionId,
    productId,
    categoryName,
    size,
    term
  } = props

  const [result, setResult] = useState([])

  const [isFetching, setIsFetching] = useState(false)

  const device = useDeviceType()
  const key = `${device}_${context}_${position}_banner`

  useEffect(() => {
    if (Boolean(context) && Boolean(sessionId) && Boolean(size)) {
      setIsFetching(true)
      ;(async () => {
        try {
          const { data: result } = await newTailRepository.getBannersAds({
            context,
            position,
            productId,
            device,
            categoryName,
            userId,
            sessionId,
            size,
            term
          })

          setResult(result)
        } catch (e) {
          datadogRum.addError(e)
        } finally {
          setIsFetching(false)
        }
      })()
    }
  }, [
    context,
    productId,
    categoryName,
    userId,
    sessionId,
    size,
    term,
    device,
    position
  ])

  return { result, isFetching, key }
}

export default useBannersAds
